import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {
    getAmplitudeInvestmentListingFiltersAppliedEventProperties,
    IGetAmplitudeInvestmentListingFiltersAppliedEventPropertiesParams
} from "./get_amplitude_investment_listing_filters_applied_event_properties";

export const trackAmplitudeInvestmentListingFiltersApplied = (params: IGetAmplitudeInvestmentListingFiltersAppliedEventPropertiesParams) => {
    trackAmplitudeEvent("listing_filters_applied", getAmplitudeInvestmentListingFiltersAppliedEventProperties(params));
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {
    getAmplitudeInvestmentListingFiltersAppliedEventProperties,
    IGetAmplitudeInvestmentListingFiltersAppliedEventPropertiesParams
} from "./get_amplitude_investment_listing_filters_applied_event_properties";

export const trackAmplitudeInvestmentListingFiltersApplied = (params: IGetAmplitudeInvestmentListingFiltersAppliedEventPropertiesParams) => {
    trackAmplitudeEvent("listing_filters_applied", getAmplitudeInvestmentListingFiltersAppliedEventProperties(params));
};
